/**
 * Portal Component
 */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { AnimatePresence } from 'framer-motion';

import { PortalProps } from './portal.types';

const Portal = ({ children, container, disablePortal = false, isTransitionable = false }: PortalProps) => {
  const [mountNode, setMountNode] = useState<Element | null>(null);

  useEffect(() => {
    if (!disablePortal) {
      // We don't want to override `null` values here as it may be possible to have
      // some DOM queries or Refs for target container to have initial values as null
      setMountNode(container || container === null ? container : document.body);
    }
  }, [container, disablePortal]);

  const content = isTransitionable ? (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    <AnimatePresence>{children}</AnimatePresence>
  ) : (
    children
  );

  if (disablePortal) {
    return React.isValidElement(content) ? content : null;
  }

  return mountNode ? ReactDOM.createPortal(content, mountNode) : null;
};

export default Portal;
